module.exports = __webpack_public_path__ + "static/media/markerIcon.f05cd031.png";